module.exports = __webpack_public_path__ + "img/174e4ca2e6a7bcb4387363a0cedb03d8.png";